import { render, staticRenderFns } from "./itemgroup.vue?vue&type=template&id=41b554ac"
import script from "./itemgroup.vue?vue&type=script&lang=js"
export * from "./itemgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports